import { Link } from "react-router-dom";
import { makeStyles } from "components/providers/makeStyles";
import { StatusPill } from "../StatusPill";
import { ArrowOutward } from "@mui/icons-material";
import { useEventObject } from "../../routes/events/id/EventProvider";

const usePartOfStyles = makeStyles(theme => ({
    series: {
        marginTop: theme.spacing(1),
    },
    rankingSeries: {
        marginTop: theme.spacing(0.5),
        paddingRight: theme.spacing(0.5),
        display: "inline-flex",
    }
}));

export const RankingsSeries = () => {
    const classes = usePartOfStyles();
    const series = useEventObject().rankingsSeries();
    if (!series.length) return null;

    return (
        <div className={classes.series}>
            {series.map(s =>
                <div key={s.id} className={classes.rankingSeries} >
                    <StatusPill
                    component={Link}
                    to={`/${s.organisation.shortName}/rankings?series=${s.id}`}
                    status="ranking"
                    target="_blank">
                        {s.name}
                        <ArrowOutward/>
                    </StatusPill>
                </div>
            )}
        </div>
    );
};
